import React from 'react';

function trailer() {
  return (
    <div style={{ width: '100vw', height: '100vh', margin: 0, padding: 0 }}>
      <iframe
        src="https://d3m9kmuzu6g4mn.cloudfront.net/trailer"
        title="Ptxinfo"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
}

export default trailer;